import React, { useState } from "react";
import axios from "axios";
import { Eyebrow } from "../components/CTA";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Contacto() {
  const [form, setForm] = useState({ nombre: "", correo: "", telefono: "", proyecto: "" });
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const update = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.nombre || !form.correo || !form.proyecto) {
      toast.error("Por favor completa nombre, correo y tu proyecto.");
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API}/contact`, form);
      setSent(true);
      toast.success("Mensaje enviado. Te respondemos en privado.");
      setForm({ nombre: "", correo: "", telefono: "", proyecto: "" });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "No pudimos enviar tu mensaje. Intenta de nuevo.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main data-testid="contacto-page" className="bg-[var(--pc-bg)] pb-20 md:pb-32">
      <section className="pc-container pt-32 md:pt-52">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 md:gap-16">
          <div className="lg:col-span-5 flex flex-col justify-center min-h-[60vh] lg:min-h-0">
            <h1
              className="headline-xl fade-up"
              style={{
                fontSize: "clamp(24px, 3.7vw, 55px)",
                letterSpacing: "0.1em",
                lineHeight: 1.14,
                wordBreak: "keep-all",
                hyphens: "none",
              }}
            >
              Iniciemos una<br />conversación<br />privada.
            </h1>
            <p className="body-soft mt-7 md:mt-10 max-w-md fade-up d1">
              Trabajamos con un grupo reducido de clientes. Cuéntanos qué quieres construir y dónde,
              y te respondemos personalmente.
            </p>
            <div className="mt-10 md:mt-16 space-y-4 label-small">
              <div>Cartagena · Barú · Colombia</div>
              <div className="text-[var(--pc-text-mute)]">Respondemos uno a uno, en privado.</div>
            </div>
          </div>

          <div className="lg:col-span-7">
            {!sent ? (
              <form
                data-testid="contact-form"
                onSubmit={onSubmit}
                className="space-y-2"
                noValidate
              >
                <input
                  data-testid="contact-input-nombre"
                  className="pc-input"
                  placeholder="Nombre"
                  value={form.nombre}
                  onChange={update("nombre")}
                  required
                />
                <input
                  data-testid="contact-input-correo"
                  className="pc-input"
                  type="email"
                  placeholder="Correo"
                  value={form.correo}
                  onChange={update("correo")}
                  required
                />
                <input
                  data-testid="contact-input-telefono"
                  className="pc-input"
                  type="tel"
                  placeholder="Teléfono (opcional)"
                  value={form.telefono}
                  onChange={update("telefono")}
                />
                <textarea
                  data-testid="contact-input-proyecto"
                  className="pc-input"
                  placeholder="Tu proyecto"
                  rows={5}
                  value={form.proyecto}
                  onChange={update("proyecto")}
                  required
                />

                <div className="pt-10">
                  <button
                    data-testid="contact-submit"
                    type="submit"
                    disabled={submitting}
                    className="cta-link disabled:opacity-50"
                  >
                    <span>{submitting ? "Enviando..." : "Enviar"}</span>
                    <span className="arr" />
                  </button>
                </div>

                <p className="label-small mt-10 text-[var(--pc-text-mute)]">
                  Respondemos uno a uno, en privado.
                </p>
              </form>
            ) : (
              <div data-testid="contact-success" className="border border-[var(--pc-line)] p-10 md:p-14">
                <Eyebrow>Mensaje recibido</Eyebrow>
                <h2 className="headline-md text-xl md:text-2xl mt-6">
                  Gracias. Pronto te respondemos.
                </h2>
                <p className="body-soft mt-6 max-w-md">
                  Recibimos tu mensaje. Te contactamos personalmente para iniciar la conversación.
                </p>
                <button
                  data-testid="contact-reset"
                  className="cta-link mt-12"
                  type="button"
                  onClick={() => setSent(false)}
                >
                  <span>Enviar otra consulta</span>
                  <span className="arr" />
                </button>
              </div>
            )}
          </div>
        </div>
      </section>
    </main>
  );
}
